import React from "react";
import {connect} from "react-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import * as CustomerActions from "./../../actions/CustomerActions"
import { closeDocumentSignModal,getProcedureStatus,closeModalCB,closeModal_2,closeModalCB_3,closeModal,closeModalCB_2 } from "../../actions/CustomerActions";
import LocalStorageService from "../../services/LocalStorageService";


@connect(store => {
	return {
		showDocumentSignModal:store.customer.showDocumentSignModal,
	    procedure: store.customer.procedure,
		showModal_2: store.customer.showModal_2,
		validateIbanAndBic: store.customer.status || "",
	}})
export default class SignDocument extends React.Component {

	constructor() {
		super();
	}

	close = () => {
		const {dispatch} = this.props;

		const {validateIbanAndBic, paymentMethod ,customerAccount, procedure} = this.props;
		const id = procedure.id.split('/');
		const procedureId = id && id[2];
		let newPaymentmethod = LocalStorageService.get('NEW_PAYMENT_METHOD');
		dispatch(getProcedureStatus(procedureId, customerAccount, newPaymentmethod, paymentMethod.id));
		dispatch(closeDocumentSignModal());
		if (validateIbanAndBic === "SUCCESS"){
			this.props.dispatch(CustomerActions.openRedirectModal())
			this.props.dispatch(CustomerActions.clear())
			this.props.dispatch(CustomerActions.deletePaymentMethod(paymentMethod.id));
			this.props.dispatch(CustomerActions.findCustomer())

		}
		this.props.dispatch(closeModalCB());
			this.props.dispatch(closeModal());
			this.props.dispatch(closeModalCB_2());
			this.props.dispatch(closeModal_2());
			this.props.dispatch(closeModalCB_3());
	};

	render() {

		const {showDocumentSignModal, procedure,showModal_2} = this.props || "";
		const members = procedure && procedure.members || [];
		const member = members && members.length > 0 && members[0] || {};
		const id = member.id || "";
		const showModal = showDocumentSignModal && !!id;
		return (showModal?
				<Dialog open={showModal} maxWidth="md" fullWidth={true}>
					<DialogContent>
						<iframe src={`${YOUSIGN_PATH}?members=${id}&signatureUi=${signatureUi}`} height="600" style={{minWidth: "99.5%"}}>{""}</iframe>
					</DialogContent>
					<DialogActions>
						<Button variant="raised" onClick={this.close} color="primary" size="large">Terminé</Button>
					</DialogActions>
				</Dialog>
				:
				null
		)
	}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/elements/SignDocument.jsx